<div class="account-card">
  <div class="header-container">
    <div class="icon-container">
      <mat-icon svgIcon={{cardIcon}}></mat-icon>
    </div>
    <h3>{{accountCard.heading}}</h3>
  </div>
  <div class="card-subtitle">
    {{accountCard.componentText}}
    <a *ngIf="accountCard.ctaNavigationItem && accountCard.ctaNavigationItem.length"
       routerLink="/tech-support-history" [state]="{ caseDetails: ctaData }">
      {{accountCard.ctaNavigationItem[0].label}}
    </a>
  </div>
  <div class="card-divider"></div>
  <ng-content></ng-content>
</div>
